<template>
  <el-drawer
    :title="title"
    :visible.sync="visible"
    direction="rtl"
    :size="450"
    :before-close="handleClose"
    :modal-append-to-body="false"
    :append-to-body="true"
    :wrapperClosable="false"
    custom-class="rule-drawer">
    <div class="rule-drawer-content" v-if="form">
      <el-form 
        :model="form" 
        :rules="rules" 
        ref="ruleForm" 
        label-width="100px"
        label-position="left"
        class="rule-form">
        <el-form-item label="规则名称" prop="ruleName">
          <el-input v-model="form.ruleName" placeholder="请输入规则名称"></el-input>
        </el-form-item>
        
        <el-form-item label="告警动作" prop="detectionMethod">
          <el-select v-model="form.detectionMethod" placeholder="请选择告警动作" style="width: 100%;" :disabled="ruleType === 'BLACKLIST'">
            <el-option
              v-for="item in computedFilteredAlertTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item v-if="form && form.detectionMethod === 'SPEED'" label="限速阈值">
          <el-input-number
            v-model="form.speedThreshold"
            :min="0"
            :step="0.5"
            :precision="1"
            controls-position="right"
            placeholder="留空则使用桥梁预警速度"
            style="width: 100%;">
          </el-input-number>
          <div class="form-help">单位：节(kn)。留空则使用桥梁“预警速度”；两者都未设置时无法保存。</div>
        </el-form-item>
        
        <el-form-item label="告警级别" prop="alertLevel">
          <el-select v-model="form.alertLevel" placeholder="请选择告警级别" style="width: 100%;">
            <el-option
              v-for="item in alertLevels"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="告警方式" prop="alertMethods">
          <el-select 
            v-model="form.alertMethods" 
            multiple 
            collapse-tags
            placeholder="请选择告警方式"
            style="width: 100%;">
            <el-option
              v-for="item in alertMethods"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="form-help">可多选，如需同时发送短信和微信通知等</div>
        </el-form-item>
        
        <el-form-item label="告警信息" prop="alertMessage">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入告警信息模板；会遇可用：{船舶名1}、{船舶名2}、{距离}；通用：{桥梁名}、{区域名}、{告警动作}、{mmsi}"
            v-model="form.alertMessage">
          </el-input>
          <div class="form-help">
            <p>支持的变量：</p>
            <template v-if="form.detectionMethod === 'MEETING'">
              <el-tag size="mini" @click="insertVariable('{船舶名1}')" class="variable-tag">{船舶名1}</el-tag>
              <el-tag size="mini" @click="insertVariable('{船舶名2}')" class="variable-tag">{船舶名2}</el-tag>
              <el-tag size="mini" @click="insertVariable('{距离}')" class="variable-tag">{距离}</el-tag>
              <el-tag size="mini" @click="insertVariable('{mmsi1}')" class="variable-tag">{mmsi1}</el-tag>
              <el-tag size="mini" @click="insertVariable('{mmsi2}')" class="variable-tag">{mmsi2}</el-tag>
              <el-tag size="mini" @click="insertVariable('{桥梁名}')" class="variable-tag">{桥梁名}</el-tag>
              <el-tag size="mini" @click="insertVariable('{区域名}')" class="variable-tag">{区域名}</el-tag>
              <el-tag size="mini" @click="insertVariable('{告警动作}')" class="variable-tag">{告警动作}</el-tag>
              <el-tag size="mini" @click="insertVariable('{时间}')" class="variable-tag">{时间}</el-tag>
            </template>
            <template v-else-if="form.detectionMethod === 'SPEED'">
              <el-tag size="mini" @click="insertVariable('{船舶名}')" class="variable-tag">{船舶名}</el-tag>
              <el-tag size="mini" @click="insertVariable('{速度}')" class="variable-tag">{速度}</el-tag>
              <el-tag size="mini" @click="insertVariable('{限速}')" class="variable-tag">{限速}</el-tag>
              <el-tag size="mini" @click="insertVariable('{桥梁名}')" class="variable-tag">{桥梁名}</el-tag>
              <el-tag size="mini" @click="insertVariable('{区域名}')" class="variable-tag">{区域名}</el-tag>
              <el-tag size="mini" @click="insertVariable('{告警动作}')" class="variable-tag">{告警动作}</el-tag>
              <el-tag size="mini" @click="insertVariable('{mmsi}')" class="variable-tag">{mmsi}</el-tag>
            </template>
            <template v-else>
              <el-tag size="mini" @click="insertVariable('{桥梁名}')" class="variable-tag">{桥梁名}</el-tag>
              <el-tag size="mini" @click="insertVariable('{船舶名}')" class="variable-tag">{船舶名}</el-tag>
              <el-tag size="mini" @click="insertVariable('{告警动作}')" class="variable-tag">{告警动作}</el-tag>
              <el-tag size="mini" @click="insertVariable('{区域名}')" class="variable-tag">{区域名}</el-tag>
              <el-tag size="mini" @click="insertVariable('{mmsi}')" class="variable-tag">{mmsi}</el-tag>
            </template>
          </div>
        </el-form-item>
        
        <el-form-item label="是否启用" prop="status">
          <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="停用">
          </el-switch>
        </el-form-item>
      </el-form>
      
      <div class="drawer-footer">
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button type="primary" size="small" @click="handleSave" :loading="saving">确定</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import * as alertApi from '@/api/alert';

export default {
  name: 'BridgeAlertRuleDrawer',
  props: {
    // 显示状态
    value: {
      type: Boolean,
      default: false
    },
    // 规则数据
    rule: {
      type: Object,
      default: null
    },
    // 区域ID
    areaId: {
      type: [Number, String],
      default: null
    },
    // 桥梁ID
    bridgeId: {
      type: [Number, String],
      default: null
    },
    // 区域名称
    areaName: {
      type: String,
      default: '未命名区域'
    },
    // 告警类型选项
    alertTypes: {
      type: Array,
      default: () => []
    },
    // 告警级别选项
    alertLevels: {
      type: Array,
      default: () => []
    },
    // 告警方式选项
    alertMethods: {
      type: Array,
      default: () => []
    },
    // 过滤后的告警动作选项
    filteredAlertTypes: {
      type: Array,
      default: () => []
    },
    // 区域类型
    areaType: {
      type: String,
      default: ''
    },
    // 规则类型，默认为AREA
    ruleType: {
      type: String,
      default: 'AREA'
    }
  },
  data() {
    return {
      visible: false,
      form: null,
      saving: false,
      title: '编辑警戒规则',
      // 规则表单验证规则
      rules: {
        ruleName: [{ required: true, message: '请输入规则名称', trigger: 'blur' }],
        detectionMethod: [{ required: true, message: '请选择告警动作', trigger: 'change' }],
        alertLevel: [{ required: true, message: '请选择告警级别', trigger: 'change' }],
        alertMethods: [{ type: 'array', required: true, message: '请选择告警方式', trigger: 'change' }],
        alertMessage: [{ required: true, message: '请输入告警信息模板', trigger: 'blur' }],
        status: [{ required: true, message: '请选择是否启用', trigger: 'change' }]
      },
      // 内部维护的表单数据副本
      localForm: null,
      // 标识是否正在初始化表单数据，防止watch误触发
      isInitializing: false
    };
  },
  watch: {
    value(val) {
      this.visible = val;
      if (val) {
        this.initForm();
      }
    },
    visible(val) {
      this.$emit('input', val);
      if (!val) {
        this.$emit('close');
      }
    },
    rule: {
      handler(val) {
        if (this.visible && val) {
          this.initForm();
        }
      },
      deep: true
    },
    // 监听localForm变化，同步到form
    localForm: {
      handler(val) {
        if (val) {
          this.form = { ...val };
        }
      },
      deep: true
    },
    
    // 监听detectionMethod变化，动态更新ruleName和alertMessage
    'form.detectionMethod': {
      handler(newVal, oldVal) {
        // 如果正在初始化或值为空，不触发更新
        if (!newVal || !this.form || this.isInitializing) {
          return;
        }
        
        console.log('检测到告警动作变更:', oldVal, '->', newVal);
        
        // 只有在创建新规则时才自动更新名称和信息
        // 编辑已有规则时保持原有值
        if (!this.rule) {
          // 简化判断逻辑，直接更新名称和信息
          const newRuleName = this.getDefaultRuleName(newVal, this.areaName);
          const newAlertMessage = this.getDefaultAlertMessage(newVal, this.areaName);
          
          // 使用Vue的方式确保响应式更新
          this.$set(this.form, 'ruleName', newRuleName);
          this.$set(this.form, 'alertMessage', newAlertMessage);
          
          console.log('已更新规则名称和告警信息:', newRuleName, newAlertMessage);
        } else {
          console.log('编辑模式下不自动更新规则名称和告警信息，保持原有值');
        }
      }
    }
  },
  computed: {
    // 根据规则类型过滤告警类型选项
    computedFilteredAlertTypes() {
      // 如果是黑名单规则类型，只显示黑名单告警类型
      if (this.ruleType === 'BLACKLIST') {
        // 检查是否已经存在黑名单选项
        const blacklistOption = this.alertTypes.find(type => type.value === 'BLACKLIST');
        if (blacklistOption) {
          return [blacklistOption];
        } else {
          // 如果不存在，创建一个
          return [{value: 'BLACKLIST', label: '黑名单告警'}];
        }
      }
      
      // 否则使用传入的过滤选项
      return this.filteredAlertTypes;
    }
  },
  methods: {
    // 获取默认告警信息模板
    getDefaultAlertMessage(detectionMethod, areaName = this.areaName) {
      console.log('detectionMethod', detectionMethod);
      switch (detectionMethod) {
        case 'ENTRY':
          return `船舶：{船舶名}，{船舶名}，进入{桥梁名} ${areaName}，请注意通航安全`;
        case 'EXIT':
          return `船舶：{船舶名}，{船舶名}，离开{桥梁名} ${areaName}，请注意通航安全`;
        case 'CROSS':
          return `船舶：{船舶名}，{船舶名}，穿越{桥梁名} ${areaName}，请注意通航安全`;
        case 'STAY':
          return `船舶：{船舶名}，{船舶名}，在{桥梁名} ${areaName}滞留超时，请及时离开`;
        case 'SPEED':
          return `船舶：{船舶名}，在{桥梁名} ${areaName}超速，当前速度{速度}节，限速{限速}节，请注意通航安全`;
        case 'YAW':
          return `船舶：{船舶名}，{船舶名}，在{桥梁名} ${areaName}偏航，请注意通航安全`;
        case 'HIGH':
          return `船舶：{船舶名}，{船舶名}，在{桥梁名} ${areaName}超高，请注意通航安全`;
        case 'MEETING':
          return `船舶：{船舶名1}，{船舶名2}，在{桥梁名} ${areaName}发生会遇，相距约{距离}米，请注意通航安全`;
        case 'BLACKLIST':
          return '发现黑名单船舶：{船舶名}，{船舶名}，请立即关注！';
        default:
          return `船舶：{船舶名}，{船舶名}，在{桥梁名} ${areaName}{告警动作}，请注意通航安全`;
      }
    },
    
    // 获取默认规则名称
    getDefaultRuleName(detectionMethod, areaName = this.areaName) {
      switch (detectionMethod) {
        case 'ENTRY':
          return `${areaName}-进入区域`;
        case 'EXIT':
          return `${areaName}-离开区域`;
        case 'CROSS':
          return `${areaName}-穿越区域`;
        case 'STAY':
          return `${areaName}-区域滞留`;
        case 'SPEED':
          return `${areaName}-区域超速`;
        case 'YAW':
          return `${areaName}-区域偏航`;
        case 'HIGH':
          return `${areaName}-区域超高`;
        case 'MEETING':
          return `${areaName}-区域会遇`;
        case 'BLACKLIST':
          return '黑名单船舶警戒规则';
        default:
          return `${areaName}-区域警戒`;
      }
    },

    initForm() {
      this.title = this.rule ? '编辑警戒规则' : '添加警戒规则';
      
      // 标记正在初始化，防止watch误触发
      this.isInitializing = true;
      
      if (this.rule) {
        // 编辑已有规则
        this.initExistingRule();
      } else {
        // 创建新规则
        this.initNewRule();
      }
      
      // 初始化完成，取消标记
      this.$nextTick(() => {
        this.isInitializing = false;
        
        // 确保表单验证重置
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    
    // 初始化已有规则表单
    initExistingRule() {
      if (!this.rule) return;
      
      // 深拷贝规则数据，避免直接修改原对象
      const ruleCopy = JSON.parse(JSON.stringify(this.rule));
      
      // 确保ruleName字段有值
      if (!ruleCopy.ruleName) {
        if (ruleCopy.alertName) {
          ruleCopy.ruleName = ruleCopy.alertName;
        } else if (ruleCopy.name) {
          ruleCopy.ruleName = ruleCopy.name;
        } else if (this.ruleType === 'BLACKLIST') {
          ruleCopy.ruleName = this.getDefaultRuleName('BLACKLIST');
        }
      }
      
      // 处理告警方式字段，将字符串转为数组
      if (typeof ruleCopy.alertMethods === 'string' && ruleCopy.alertMethods) {
        ruleCopy.alertMethods = ruleCopy.alertMethods.split(',');
      } else if (!Array.isArray(ruleCopy.alertMethods) || ruleCopy.alertMethods.length === 0) {
        // 如果没有告警方式或不是数组，使用默认值
        ruleCopy.alertMethods = this.alertMethods.length > 0 ?
          [this.alertMethods[0].value] : ['SYSTEM'];
      }
      
      // 确保status字段为数字
      if (ruleCopy.status === true) {
        ruleCopy.status = 1;
      } else if (ruleCopy.status === false) {
        ruleCopy.status = 0;
      } else if (ruleCopy.status === undefined || ruleCopy.status === null) {
        ruleCopy.status = 1;
      }
      
      // 确保detectionMethod字段有值
      if (!ruleCopy.detectionMethod) {
        if (ruleCopy.ruleType) {
          ruleCopy.detectionMethod = ruleCopy.ruleType;
        } else if (ruleCopy.alertType) {
          ruleCopy.detectionMethod = ruleCopy.alertType;
        } else if (this.ruleType === 'BLACKLIST') {
          ruleCopy.detectionMethod = 'BLACKLIST';
        } else if (this.alertTypes.length > 0) {
          // 默认使用第一个告警类型
          ruleCopy.detectionMethod = this.alertTypes[0].value;
        } else {
          // 兜底默认值
          ruleCopy.detectionMethod = 'ENTRY';
        }
      }
      
      // 确保alertLevel字段有值
      if (!ruleCopy.alertLevel) {
        // 黑名单默认为高级别告警
        if (this.ruleType === 'BLACKLIST') {
          ruleCopy.alertLevel = 'WARNING';
        } else {
          // 尝试找到中级警告
          const mediumLevel = this.alertLevels.find(l => 
            l.value === 'INFO' || l.value === '2'
          );
          
          ruleCopy.alertLevel = mediumLevel ? 
            mediumLevel.value : 
            (this.alertLevels.length > 0 ? this.alertLevels[0].value : 'INFO');
        }
      }
      
      // 确保alertMessage字段有值
      if (!ruleCopy.alertMessage) {
        ruleCopy.alertMessage = this.getDefaultAlertMessage(ruleCopy.detectionMethod);
      }
      
      // 确保设置了ruleType
      ruleCopy.ruleType = ruleCopy.ruleType || this.ruleType;
      
      // 解析超速限速（rule_condition.speedThreshold），未配置则为空
      ruleCopy.speedThreshold = null;
      if (ruleCopy.ruleCondition) {
        try {
          const condition = typeof ruleCopy.ruleCondition === 'string'
            ? JSON.parse(ruleCopy.ruleCondition)
            : ruleCopy.ruleCondition;
          const threshold = condition && (condition.speedThreshold !== undefined ? condition.speedThreshold : condition.speedLimit);
          if (threshold !== undefined && threshold !== null && Number(threshold) > 0) {
            ruleCopy.speedThreshold = Number(threshold);
          }
        } catch (e) {
          ruleCopy.speedThreshold = null;
        }
      }
      
      // 设置表单数据
      this.form = ruleCopy;
      this.localForm = { ...ruleCopy };
    },
    
    // 初始化新规则表单
    initNewRule() {
      // 如果没有区域ID，显示警告
      if (!this.areaId && this.ruleType !== 'BLACKLIST') {
        this.$message.warning('请先保存区域后再添加警戒规则');
        this.handleClose();
        return;
      }
      
      // 获取默认的告警级别
      let defaultAlertLevel = 'INFO';
      if (this.alertLevels.length > 0) {
        const mediumLevel = this.alertLevels.find(l => l.value === 'INFO' || l.value === '2');
        defaultAlertLevel = mediumLevel ? mediumLevel.value : this.alertLevels[0].value;
      }
      
      // 获取默认的告警方式
      let defaultAlertMethods = ['SYSTEM'];
      if (this.alertMethods.length > 0) {
        const systemMethod = this.alertMethods.find(m => m.value === 'SYSTEM');
        defaultAlertMethods = systemMethod ? ['SYSTEM'] : [this.alertMethods[0].value];
      }
      
      // 获取默认的检测方法
      let defaultDetectionMethod = 'ENTRY';
      if (this.filteredAlertTypes.length > 0) {
        defaultDetectionMethod = this.filteredAlertTypes[0].value;
      }
      
      // 根据规则类型设置特定属性
      const detectionMethod = this.ruleType === 'BLACKLIST' ? 'BLACKLIST' : defaultDetectionMethod;
      
      // 创建新规则对象
      const newForm = {
        id: null,
        areaId: this.areaId,
        bridgeId: this.bridgeId,
        ruleType: this.ruleType,
        detectionMethod: detectionMethod,
        ruleName: this.getDefaultRuleName(detectionMethod),
        alertMessage: this.getDefaultAlertMessage(detectionMethod),
        alertLevel: this.ruleType === 'BLACKLIST' ? 'WARNING' : defaultAlertLevel,
        alertMethods: defaultAlertMethods,
        status: 1,
        threshold: 0,
        speedThreshold: null,
        ruleCondition: '{}',
        priority: 1,
        description: ''
      };
      
      // 设置表单数据
      this.form = newForm;
      this.localForm = { ...newForm };
    },
    
    // 关闭抽屉
    handleClose() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
      this.visible = false;
      this.form = null;
      this.localForm = null;
      this.isInitializing = false; // 重置初始化标记
    },
    
    // 保存规则
    async handleSave() {
      if (!this.$refs.ruleForm) {
        console.error('表单引用不存在');
        return;
      }
      
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) {
          this.$message.warning('请完善表单信息');
          return;
        }
        
        this.saving = true;
        
        try {
          // 使用当前表单数据
          const ruleData = { ...this.form };
          
          // 确保规则数据包含bridgeId和areaId
          ruleData.bridgeId = this.bridgeId;
          ruleData.areaId = this.areaId;
          
          // 处理alertMethods字段，将数组转为逗号分隔的字符串
          if (Array.isArray(ruleData.alertMethods)) {
            ruleData.alertMethods = ruleData.alertMethods.join(',');
          }
          
          // 添加必要的字段
          ruleData.ruleType = ruleData.ruleType || this.ruleType;
          
          // 确保detectionMethod字段有值
          if (!ruleData.detectionMethod) {
            ruleData.detectionMethod = ruleData.alertType || 'ENTRY';
          }
          
          // 确保alertType字段有值（兼容旧接口）
          if (!ruleData.alertType && ruleData.detectionMethod) {
            ruleData.alertType = ruleData.detectionMethod;
          }
          
          // 兼容处理：如果有alertName但没有ruleName，则使用alertName的值
          if (!ruleData.ruleName && ruleData.alertName) {
            ruleData.ruleName = ruleData.alertName;
          }
          
          // 超速：把限速阈值写入 rule_condition（留空则回退桥梁预警速度）
          if (ruleData.detectionMethod === 'SPEED') {
            const threshold = Number(ruleData.speedThreshold);
            ruleData.ruleCondition = threshold > 0
              ? JSON.stringify({ speedThreshold: threshold })
              : JSON.stringify({});
          }
          delete ruleData.speedThreshold;
          
          // 确保JSON字段
          ruleData.ruleCondition = ruleData.ruleCondition || JSON.stringify({});
          ruleData.alertAction = ruleData.alertAction || JSON.stringify({});
          ruleData.priority = ruleData.priority || 1;
          
          let res;
          
          if (!ruleData.id) {
            // 创建新规则
            res = await alertApi.createAlertRule(ruleData);
          } else {
            // 更新已有规则
            res = await alertApi.updateAlertRule(ruleData.id, ruleData);
          }
          
          if (res && res.code === 200) {
            this.$message.success('保存规则成功');
            this.$emit('success', res.data);
            this.handleClose();
          } else {
            this.$message.error((res && res.msg) || '保存规则失败');
          }
        } catch (error) {
          console.error('保存规则出错:', error);
          const responseData = error && error.response && error.response.data;
          const msg = (responseData && (responseData.msg || responseData.message))
            || (error && error.message)
            || '保存规则失败';
          this.$message.error(msg);
        } finally {
          this.saving = false;
        }
      });
    },
    
    // 插入变量到告警信息模板
    insertVariable(variable) {
      const textarea = this.$refs.ruleForm.$el.querySelector('textarea[v-model="form.alertMessage"]');
      if (textarea) {
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        this.$nextTick(() => {
          textarea.value = textarea.value.substring(0, start) + variable + textarea.value.substring(end);
          textarea.selectionStart = start + variable.length;
          textarea.selectionEnd = start + variable.length;
        });
      }
    }
  }
};
</script>

<style scoped>
/* 规则抽屉样式 */
.rule-drawer {
  overflow: hidden;
}

.rule-drawer-content {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.rule-form {
  flex: 1;
  overflow-y: auto;
}

.drawer-footer {
  padding: 10px 20px;
  border-top: 1px solid #e6e6e6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin: 0 -20px;
  background-color: #fff;
}

.form-help {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}

.variable-tag {
  margin-right: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}

.variable-tag:hover {
  opacity: 0.8;
}

/* 修改全局抽屉样式 */
:deep(.el-drawer__container) {
  position: absolute !important;
}

:deep(.el-drawer__mask) {
  background-color: transparent !important;
}
</style> 